import { avatarAssetUrl } from "./assetUrl";
import type { AvatarPart } from './parts';

/** Approved collection with calibrated avatar geometry. */
export const COLLECTION_PARTS: AvatarPart[] = [
  {
    "id": "jersey_chelsea",
    "name": "Chelsea",
    "slot": "jersey",
    "position": {
      "top": 43.0,
      "left": 12.5,
      "width": 70.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_chelsea.webp"),
    "productSlug": "avatar_jersey_chelsea"
  },
  {
    "id": "jersey_tottenham",
    "name": "Tottenham",
    "slot": "jersey",
    "position": {
      "top": 43.0,
      "left": 12.0,
      "width": 71.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_tottenham.webp"),
    "productSlug": "avatar_jersey_tottenham"
  },
  {
    "id": "jersey_benfica",
    "name": "Benfica",
    "slot": "jersey",
    "position": {
      "top": 42.25,
      "left": 11.5,
      "width": 71.5
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_benfica.webp"),
    "productSlug": "avatar_jersey_benfica"
  },
  {
    "id": "jersey_porto",
    "name": "Porto",
    "slot": "jersey",
    "position": {
      "top": 43.0,
      "left": 12.5,
      "width": 70.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_porto.webp"),
    "productSlug": "avatar_jersey_porto"
  },
  {
    "id": "jersey_sporting",
    "name": "Sporting",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_sporting.webp"),
    "productSlug": "avatar_jersey_sporting"
  },
  {
    "id": "jersey_marseille",
    "name": "Marseille",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_marseille.webp"),
    "productSlug": "avatar_jersey_marseille"
  },
  {
    "id": "jersey_galatasaray",
    "name": "Galatasaray",
    "slot": "jersey",
    "position": {
      "top": 43.5,
      "left": 13.25,
      "width": 69.25
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_galatasaray.webp"),
    "productSlug": "avatar_jersey_galatasaray"
  },
  {
    "id": "jersey_fenerbahce",
    "name": "Fenerbahçe",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_fenerbahce.webp"),
    "productSlug": "avatar_jersey_fenerbahce"
  },
  {
    "id": "jersey_boca_juniors",
    "name": "Boca Juniors",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_boca_juniors.webp"),
    "productSlug": "avatar_jersey_boca_juniors"
  },
  {
    "id": "jersey_river_plate",
    "name": "River Plate",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_river_plate.webp"),
    "productSlug": "avatar_jersey_river_plate"
  },
  {
    "id": "jersey_portugal",
    "name": "Portugal",
    "slot": "jersey",
    "position": {
      "top": 43.0,
      "left": 12.75,
      "width": 70.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_portugal.webp"),
    "productSlug": "avatar_jersey_portugal"
  },
  {
    "id": "jersey_spain",
    "name": "Spain",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_spain.webp"),
    "productSlug": "avatar_jersey_spain"
  },
  {
    "id": "jersey_croatia",
    "name": "Croatia",
    "slot": "jersey",
    "position": {
      "top": 43.25,
      "left": 12.5,
      "width": 70.75
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_croatia.webp"),
    "productSlug": "avatar_jersey_croatia"
  },
  {
    "id": "jersey_japan",
    "name": "Japan",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_japan.webp"),
    "productSlug": "avatar_jersey_japan"
  },
  {
    "id": "jersey_morocco",
    "name": "Morocco",
    "slot": "jersey",
    "position": {
      "top": 43.75,
      "left": 13.25,
      "width": 69.25
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_morocco.webp"),
    "productSlug": "avatar_jersey_morocco"
  },
  {
    "id": "jersey_nigeria",
    "name": "Nigeria",
    "slot": "jersey",
    "position": {
      "top": 43.75,
      "left": 12.5,
      "width": 70.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_nigeria.webp"),
    "productSlug": "avatar_jersey_nigeria"
  },
  {
    "id": "jersey_mexico",
    "name": "Mexico",
    "slot": "jersey",
    "position": {
      "top": 43.0,
      "left": 12.75,
      "width": 70.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_mexico.webp"),
    "productSlug": "avatar_jersey_mexico"
  },
  {
    "id": "jersey_uruguay",
    "name": "Uruguay",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_uruguay.webp"),
    "productSlug": "avatar_jersey_uruguay"
  },
  {
    "id": "jersey_retro_keeper",
    "name": "Retro Goalkeeper",
    "slot": "jersey",
    "position": {
      "top": 43.75,
      "left": 12.75,
      "width": 70.0
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_retro_keeper.webp"),
    "productSlug": "avatar_jersey_retro_keeper"
  },
  {
    "id": "jersey_neon_training",
    "name": "Neon Training",
    "slot": "jersey",
    "position": {
      "top": 44.0,
      "left": 13.0,
      "width": 69.25
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_neon_training.webp"),
    "productSlug": "avatar_jersey_neon_training"
  },
  {
    "id": "jersey_street_football",
    "name": "Street Football",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_street_football.webp"),
    "productSlug": "avatar_jersey_street_football"
  },
  {
    "id": "jersey_gold_champion",
    "name": "Gold Champion",
    "slot": "jersey",
    "position": {
      "top": 43,
      "left": 13,
      "width": 70
    },
    "priceCoins": 10000,
    "group": "Jerseys",
    "asset": avatarAssetUrl("/assets/store/collection/jersey_gold_champion.webp"),
    "productSlug": "avatar_jersey_gold_champion"
  },
  {
    "id": "hair_ronaldinho",
    "name": "Ronaldinho",
    "slot": "hair",
    "position": {
      "top": -5.25,
      "left": 16.0,
      "width": 48.25
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_ronaldinho.webp"),
    "productSlug": "avatar_hair_ronaldinho",
    "storePosition": {
      "top": -2,
      "left": 18.75,
      "width": 46.85
    }
  },
  {
    "id": "hair_neymar_mohawk",
    "name": "Neymar Mohawk",
    "slot": "hair",
    "position": {
      "top": -11.5,
      "left": 21.0,
      "width": 48.5
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_neymar_mohawk.webp"),
    "productSlug": "avatar_hair_neymar_mohawk",
    "storePosition": {
      "top": -7.25,
      "left": 27.5,
      "width": 41.05
    }
  },
  {
    "id": "hair_zidane",
    "name": "Zidane",
    "slot": "hair",
    "position": {
      "top": 0.75,
      "left": 24.75,
      "width": 41.0
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_zidane.webp"),
    "productSlug": "avatar_hair_zidane",
    "clipPath": "polygon(0 30%, 24% 30%, 36% 100%, 0 100%)",
    "storePosition": {
      "top": 3,
      "left": 29,
      "width": 39.14
    }
  },
  {
    "id": "hair_haaland",
    "name": "Haaland",
    "slot": "hair",
    "position": {
      "top": -4.0,
      "left": 18.5,
      "width": 48.5
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_haaland.webp"),
    "productSlug": "avatar_hair_haaland",
    "storePosition": {
      "top": -1,
      "left": 23,
      "width": 44.16
    }
  },
  {
    "id": "hair_beckham_mohawk",
    "name": "Beckham Mohawk",
    "slot": "hair",
    "position": {
      "top": -10.25,
      "left": 21.25,
      "width": 45.0
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_beckham_mohawk.webp"),
    "productSlug": "avatar_hair_beckham_mohawk",
    "storePosition": {
      "top": -4.75,
      "left": 27.75,
      "width": 39.96
    }
  },
  {
    "id": "hair_valderrama",
    "name": "Valderrama",
    "slot": "hair",
    "position": {
      "top": -18.0,
      "left": 14.5,
      "width": 64.25
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_valderrama.webp"),
    "productSlug": "avatar_hair_valderrama",
    "storePosition": {
      "top": -20.75,
      "left": 7.5,
      "width": 70
    },
    "hairFrontPercent": 80.5
  },
  {
    "id": "hair_gullit",
    "name": "Gullit",
    "slot": "hair",
    "position": {
      "top": -6.0,
      "left": 17.0,
      "width": 55.25
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_gullit.webp"),
    "productSlug": "avatar_hair_gullit",
    "storePosition": {
      "top": -3,
      "left": 20,
      "width": 51.52
    }
  },
  {
    "id": "hair_baggio",
    "name": "Baggio",
    "slot": "hair",
    "position": {
      "top": -3.75,
      "left": 16.25,
      "width": 60.5
    },
    "priceCoins": 6000,
    "group": "Iconic players",
    "asset": avatarAssetUrl("/assets/store/collection/hair_baggio.webp"),
    "productSlug": "avatar_hair_baggio",
    "storePosition": {
      "top": -1.5,
      "left": 21.25,
      "width": 48.25
    }
  },
  {
    "id": "hair_high_afro",
    "name": "High Afro",
    "slot": "hair",
    "position": {
      "top": -13.5,
      "left": 20.75,
      "width": 49.5
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_high_afro.webp"),
    "productSlug": "avatar_hair_high_afro",
    "storePosition": {
      "top": -4,
      "left": 24,
      "width": 45.080000000000005
    },
    "hairFrontPercent": 85.5
  },
  {
    "id": "hair_braided_bun",
    "name": "Braided Bun",
    "slot": "hair",
    "position": {
      "top": -14.25,
      "left": 18.0,
      "width": 49.75
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_braided_bun.webp"),
    "productSlug": "avatar_hair_braided_bun",
    "storePosition": {
      "top": -7.75,
      "left": 22.5,
      "width": 47.08
    },
    "hairFrontPercent": 56.5,
    "storeHairFrontPercent": 100
  },
  {
    "id": "hair_ponytail",
    "name": "Ponytail",
    "slot": "hair",
    "position": {
      "top": -10.0,
      "left": 14.0,
      "width": 54.5
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_ponytail.webp"),
    "productSlug": "avatar_hair_ponytail",
    "storePosition": {
      "top": -4,
      "left": 24,
      "width": 45.080000000000005
    },
    "hairFrontPercent": 100
  },
  {
    "id": "hair_messy_fringe",
    "name": "Messy Fringe",
    "slot": "hair",
    "position": {
      "top": -6.25,
      "left": 20.75,
      "width": 50.75
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_messy_fringe.webp"),
    "productSlug": "avatar_hair_messy_fringe",
    "storePosition": {
      "top": -4,
      "left": 24,
      "width": 45.080000000000005
    },
    "hairFrontPercent": 100
  },
  {
    "id": "hair_mullet",
    "name": "Mullet",
    "slot": "hair",
    "position": {
      "top": -7.0,
      "left": 20.0,
      "width": 49.0
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_mullet.webp"),
    "productSlug": "avatar_hair_mullet",
    "storePosition": {
      "top": -4,
      "left": 24,
      "width": 45.080000000000005
    }
  },
  {
    "id": "hair_spiky",
    "name": "Spiky Hair",
    "slot": "hair",
    "position": {
      "top": -18.75,
      "left": 22.25,
      "width": 56.25
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_spiky.webp"),
    "productSlug": "avatar_hair_spiky",
    "storePosition": {
      "top": -13.5,
      "left": 25,
      "width": 50.83
    }
  },
  {
    "id": "hair_shoulder_curls",
    "name": "Shoulder Curls",
    "slot": "hair",
    "position": {
      "top": -8.0,
      "left": 19.25,
      "width": 56.25
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_shoulder_curls.webp"),
    "productSlug": "avatar_hair_shoulder_curls",
    "storePosition": {
      "top": -4.75,
      "left": 24.25,
      "width": 51.33
    },
    "hairFrontPercent": 79
  },
  {
    "id": "hair_side_shave",
    "name": "Side Shave",
    "slot": "hair",
    "position": {
      "top": -9.25,
      "left": 24.75,
      "width": 47.75
    },
    "priceCoins": 6000,
    "group": "Hair",
    "asset": avatarAssetUrl("/assets/store/collection/hair_side_shave.webp"),
    "productSlug": "avatar_hair_side_shave",
    "storePosition": {
      "top": -5.25,
      "left": 24,
      "width": 49.58
    },
    "hairFrontPercent": 55
  },
  {
    "id": "headwear_cech",
    "name": "Čech Headguard",
    "slot": "headwear",
    "position": {
      "top": -6.0,
      "left": 20.75,
      "width": 50.75
    },
    "priceCoins": 6000,
    "group": "Headwear",
    "hideHair": true,
    "asset": avatarAssetUrl("/assets/store/collection/headwear_cech.webp"),
    "productSlug": "avatar_headwear_cech"
  },
  {
    "id": "facial_long",
    "name": "Long Beard",
    "slot": "facialHair",
    "position": {
      "top": 20.0,
      "left": 36.5,
      "width": 36.0
    },
    "priceCoins": 4000,
    "group": "Facial hair",
    "asset": avatarAssetUrl("/assets/store/collection/facial_long.webp"),
    "productSlug": "avatar_facial_long",
    "storePosition": {
      "top": 23.75,
      "left": 36.5,
      "width": 36
    }
  },
  {
    "id": "facial_chin_goatee",
    "name": "Chin Goatee",
    "slot": "facialHair",
    "position": {
      "top": 34.0,
      "left": 55.75,
      "width": 12.0
    },
    "priceCoins": 4000,
    "group": "Facial hair",
    "asset": avatarAssetUrl("/assets/store/collection/facial_chin_goatee.webp"),
    "productSlug": "avatar_facial_chin_goatee"
  },
  {
    "id": "earwear_studs",
    "name": "Stud Earrings",
    "slot": "earwear",
    "position": {
      "top": 32.0,
      "left": 29.75,
      "width": 3.5
    },
    "priceCoins": 3000,
    "group": "Accessories",
    "asset": avatarAssetUrl("/assets/store/collection/earwear_studs.webp"),
    "productSlug": "avatar_earwear_studs"
  },
  {
    "id": "earwear_hoop",
    "name": "Hoop Earring",
    "slot": "earwear",
    "position": {
      "top": 34.0,
      "left": 28.25,
      "width": 5.5
    },
    "priceCoins": 3000,
    "group": "Accessories",
    "asset": avatarAssetUrl("/assets/store/collection/earwear_hoop.webp"),
    "productSlug": "avatar_earwear_hoop",
    "storePosition": {
      "top": 34,
      "left": 31,
      "width": 5.5
    }
  }
];
